import React, { memo, useMemo } from 'react';
import classnames from 'classnames';
import EllipsisTextBubble from '@gp/components/EllipsisTextBubble';
import GeneralImageNew from '@gp/components/GeneralImageNew';
import LinkJump from '@gp/components/LinkJump';
import { MENU_ID_MAP } from '@gp/constants/const';
import { queryJumpable } from '@gp/utils/common';
import '@gp/pages/StudioDashboard/StudioOverall/Tabs/Overview/components/KeyInformationTable/components/StudioSummaryCard/index.scss';

const StudioSummaryCard: React.FC<IStudioSummaryCardProps> = (props) => {
  const {
    name,
    cover,
    addr,
    nationalFlag,
    className,
    onClick,
    style,
    ...remains
  } = props;

  const handleClick = (
    e: React.MouseEvent<Element, MouseEvent> | null,
    isJump = true,
  ): string => {
    if (isJump && e) {
      onClick?.(e);
    }
    return onClick?.(e, isJump) as string;
  };

  const url = useMemo(() => {
    if (!remains?.id) return '';
    const filter = encodeURIComponent(
      JSON.stringify({
        studioId: remains?.id || '',
        studioName: name || '',
        menuFrom: MENU_ID_MAP['studio-dashboard_studio-overall'], // 用于标识左侧菜单栏当前选中高亮
      }),
    );
    const url = `/Studio/PortfolioOverview/Detail?filter=${filter}`;

    return url;
  }, [remains, name]);

  return (
    <div
      {...remains}
      style={style}
      className={classnames(
        'dbg-stuodio-overall-studio-summary-card',
        className,
      )}
    >
      <div className="dbg-studio-overall-studio-summary-logo">
        <LinkJump url={url}>
          <GeneralImageNew
            className="dbg-studio-overall-studio-summary-logo-img-comp"
            domain="studio"
            width={54}
            height={54}
            src={cover}
            onClick={(e: React.MouseEvent<Element, MouseEvent>) => {
              if (!queryJumpable(e)) return;
              e?.preventDefault();
              e?.stopPropagation();
              handleClick(e);
            }}
          />
        </LinkJump>
      </div>
      <div className="dbg-studio-overall-studio-summary-details">
        {/* <h3>{name}</h3> */}
        <h3
          onClick={(e) => {
            if (!queryJumpable(e)) return;
            e?.preventDefault();
            e?.stopPropagation();
            handleClick(e);
          }}
        >
          <LinkJump
            stopPropagation={false}
            style={{ textDecoration: 'none'}}
            url={url}
          >
            <EllipsisTextBubble
              className="dbg-studio-overall-studio-summary-title"
              ellipsisLineClamp={2}
              text={name || '-'}
            />
          </LinkJump>
        </h3>
        <div>
          <div className="dbg-studio-overall-studio-summary-addr-icon">
            {/* <GeneralImageNew width={16} height={10} src={nationalFlag} errorImg={null} /> */}
            <img width={18} height={12} src={nationalFlag} />
          </div>
          {/* <div className="gp-studio-overall-studio-summary-addr">{addr}</div> */}
          <div className="dbg-studio-overall-studio-summary-addr">
            <EllipsisTextBubble text={addr || '-'} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(StudioSummaryCard);
